/*eslint linebreak-style: ["error", "windows"]*/
<template>
  <v-app>
    <v-content>
      <v-container>
        <Home />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Home from './components/Home.vue';

export default {
  name: 'App',

  components: {
    Home,
  },

  data: () => ({
    //
  }),
};
</script>
